<template>
  <el-button-group>
    <el-button v-if="this.$fun.isQx(this.qx, 'admin:add')" type="primary" icon="Plus" @click="addInfo">添加</el-button>
    <el-button v-if="this.$fun.isQx(this.qx, 'admin:del')" type="danger" icon="Delete" @click="delInfo">删除</el-button>
    <el-button v-if="this.$fun.isQx(this.qx, 'admin:enable')" type="success" icon="CircleCheck" @click="enableInfo(true)">启用</el-button>
    <el-button v-if="this.$fun.isQx(this.qx, 'admin:enable')" type="info" icon="CircleClose" @click="enableInfo(false)">禁用</el-button>
    <el-button v-if="this.$fun.isQx(this.qx, 'admin:role')" type="warning" icon="Key" @click="setRole">设置角色</el-button>
  </el-button-group>
  <div class="fun">
    <div class="search-div">
      <el-input placeholder="请输入用户名/姓名/电话关键字" prefix-icon="search" v-model="searchKey" clearable class="width3"></el-input>
      <el-button type="primary" icon="search" @click="getData">查询</el-button>
    </div>
    <STC colName="adminColumn" :colList="colList" />
  </div>
  <el-row :gutter="2">
    <el-col :span="5" class="box">
      <div class="title">组织机构</div>
      <!-- <el-scrollbar class="depatree"> -->
        <div class="depatree">
          <el-checkbox v-model="depInclude">包含下级部门</el-checkbox>
          <el-tree ref="tree" node-key="value" :data="depaData"
            @node-click="handleNodeClick" highlight-current default-expand-all :expand-on-click-node="false">
          </el-tree>
        </div>
      <!-- </el-scrollbar> -->
    </el-col>
    <el-col :span="19">
      <el-table v-loading="tableLoading" :data="tableData" highlight-current-row stripe border
          :height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange"
          header-row-class-name="header-row" header-cell-class-name="header-cell">
        <el-table-column type="selection" width="40"></el-table-column>
        <!-- <el-table-column type="index" label="序" width="40"></el-table-column> -->
        <el-table-column v-if="this.$fun.isExist(checkColList, '用户名')" prop="adminName" label="用户名" sortable width="100"></el-table-column>
        <el-table-column v-if="this.$fun.isExist(checkColList, '姓名')" label="姓名" width="120">
          <template #default="scope">
            {{scope.row.name}} ({{scope.row.gender}})
            <!-- <el-icon v-if="scope.row.gender === '男'" class="check" title="男"><Male /></el-icon>
            <el-icon v-else class="check" title="女"><Female /></el-icon> -->
          </template>
        </el-table-column>
        <el-table-column v-if="this.$fun.isExist(checkColList, '联系电话')" prop="phone" label="联系电话" width="130"></el-table-column>
        <el-table-column v-if="this.$fun.isExist(checkColList, '电子邮箱')"  prop="email" label="电子邮箱" ></el-table-column>
        <el-table-column v-if="this.$fun.isExist(checkColList, '联系地址')" prop="address" label="联系地址" ></el-table-column>
        <el-table-column v-if="this.$fun.isExist(checkColList, '小程序角色')" prop="mpQx" label="小程序角色" ></el-table-column>
        <el-table-column v-if="this.$fun.isExist(checkColList, '排序')" prop="queue" label="排序" width="60"></el-table-column>
        <el-table-column v-if="this.$fun.isExist(checkColList, '状态')" label="状态" width="60">
          <template #default="scope">
            <el-icon v-if="scope.row.isEnable" class="check" title="启用"><Check /></el-icon>
            <el-icon v-else class="close" title="禁用"><Close /></el-icon>
          </template>
        </el-table-column>
        <el-table-column v-if="this.$fun.isExist(checkColList, '录入时间')" prop="upTime" label="录入时间" sortable width="150"></el-table-column>
        <el-table-column label="操作" width="60">
          <template #default="scope">
            <el-link v-if="this.$fun.isQx(this.qx, 'admin:edit')" type="primary" :underline="false" @click="editInfo(scope.row.id)">修改</el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-sizes="[10, 15, 20, 30, 40]"
        :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total='tableTotal'>
      </el-pagination>
    </el-col>
  </el-row>
  <el-dialog :title="dialogTitle" v-model="dialogFormVisible" :close-on-click-modal="false" :before-close="closeForm">
    <el-form ref="formRef" :model="form" :rules="rules" label-width="130px">
      <el-input v-model="form.id" type="hidden"></el-input>
      <el-form-item label="部门" prop="departmentId">
        <el-tree-select v-model="form.departmentId" :data="depaData" placeholder="请选择一个部门"
          highlight-current default-expand-all check-strictly=true />
      </el-form-item>
      <el-form-item label="用户名" prop="adminName">
          <el-input v-model="form.adminName" class="width"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="adminPwd">
        <el-input v-model="form.adminPwd" show-password class="width"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" maxlength="50" class="width"></el-input>
      </el-form-item>
      <el-form-item label="性别" prop="gender">
        <el-radio-group v-model="form.gender">
          <el-radio-button label="男">男</el-radio-button>
          <el-radio-button label="女">女</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="联系电话" prop="phone">
          <el-input v-model="form.phone" maxlength="50" class="width1"></el-input>
      </el-form-item>
      <el-form-item label="电子邮件" prop="email">
        <el-input v-model="form.email" maxlength="100" class="width1"></el-input>
      </el-form-item>
      <el-form-item label="联系地址" prop="address">
          <el-input v-model="form.address" maxlength="100" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="小程序角色" prop="mpQx">
          <el-select v-model="form.mpQx" multiple placeholder="请选择小程序角色" class="width4">
            <el-option v-for="item in mpQxData" :key="item.value" :label="item.key" :value="item.value" />
          </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" type="textarea" maxlength="200" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="排序">
        <el-input-number v-model="form.queue" :min="0" />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeForm">关 闭</el-button>
        <el-button @click="resetForm">重 填</el-button>
        <el-button type="primary" @click="saveInfo">确 定</el-button>
      </span>
    </template>
  </el-dialog>
  <!-- 设置角色对话框 -->
  <el-dialog title="设置角色" v-model="dialogRoleVisible" :close-on-click-modal="false">
    <el-table ref="userRoleTable" v-loading="tableRoleLoading" :data="userRoleData" highlight-current-row stripe border
     style="width: 100%" @selection-change="handleSelectionChangeRole"
    header-row-class-name="header-row" header-cell-class-name="header-cell">
    <el-table-column type="selection" width="40"></el-table-column>
    <el-table-column type="index" label="序" width="40"></el-table-column>
    <el-table-column prop="name" label="角色名称" width="120"></el-table-column>
    <el-table-column prop="desc" label="角色描述" show-overflow-tooltip></el-table-column>
    </el-table>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeFormRole">关 闭</el-button>
        <el-button type="primary" @click="saveSet">确 定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
// 选择显示的表列
import STC from '@/components/SelectTableColumn'
export default {
  name: 'admin',
  components: {
    STC
  },
  data () {
    return {
      qx: '',
      colList: ['用户名', '姓名', '联系电话', '电子邮箱', '联系地址', '小程序角色', '排序', '状态', '录入时间'],
      checkColList: [],
      tableLoading: false,
      currentPage: 1,
      pagesize: 15,
      tableTotal: 0,
      tableData: [],
      selectionIds: '',
      dialogFormVisible: false,
      dialogTitle: '',
      form: {
        id: '',
        departmentId: '',
        adminName: '',
        adminPwd: '',
        name: '',
        gender: '男',
        phone: '',
        email: '',
        address: '',
        mpQx: [],
        remark: '',
        queue: 0
      },
      rules: {
        departmentId: [
          { required: true, message: '请选择一个部门', trigger: 'change' }
        ],
        adminName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        adminPwd: [
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ]
      },
      depId: '',
      depInclude: false,
      searchKey: '',
      depaData: [],
      aid: '',
      tableRoleLoading: false,
      dialogRoleVisible: false,
      userRoleData: [],
      selRoleIds: '',
      mpQxData: []
    }
  },
  // 接收父组件传值
  props: ['clientHeight'],
  mounted () {
    this.qx = this.$route.params.qx
    this.getTableHeight()
    this.getData()
    this.getDepaData()
    this.getQxData()
  },
  methods: {
    // 当表格的当前行发生变化的时候会触发该事件
    // handleCurrentRowChange (val) {
    //   this.currentRow = val
    //   // console.log('currentRow=', this.currentRow)
    // },
    // pageSize 新每页条数改变时触发(每页下拉显示数据)
    handleSizeChange (size) {
      this.pagesize = size
      this.getData()
    },
    // 新当前页改变时触发(点击第几页)
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.getData()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.selectionIds = ''
      for (var i = 0; i < val.length; i++) {
        if (this.selectionIds === '') {
          this.selectionIds = val[i].id
        } else {
          this.selectionIds += ',' + val[i].id
        }
      }
    },
    // 部门信息上级pid
    handleNodeClick (data) {
      this.depId = data.value
      this.getData()
    },
    async getData () {
      this.tableLoading = true
      const params = '?key=' + this.searchKey + '&depid=' + this.depId + '&depInc=' + this.depInclude + '&pagesize=' + this.pagesize + '&pageindex=' + this.currentPage
      const { data: ret } = await this.$http.get(this.$api.adminlist + params)
      if (ret.status === 0) {
        this.tableData = ret.data.rows
        this.tableTotal = ret.data.total
      }
      this.tableLoading = false
    },
    async getDepaData () {
      const { data: ret } = await this.$http.get(this.$api.depadowndepa + '?bo=' + false)
      if (ret.status === 0) {
        if (ret.data === null) {
          this.$message({
            message: ret.message,
            type: 'warning'
          })
          return
        }
        this.depaData = ret.data
      }
    },
    async getQxData () {
      const { data: ret } = await this.$http.get(this.$api.dictItemListByCode + '?code=mpqx-type')
      // console.log('typeret=', ret)
      if (ret.status === 0) {
        if (ret.data === null) {
          this.$message({
            message: ret.message,
            type: 'warning'
          })
          return
        }
        this.mpQxData = ret.data
      }
    },
    addInfo () {
      this.form.id = ''
      this.dialogTitle = '添加用户'
      this.dialogFormVisible = true
    },
    async editInfo (id) {
      // if (this.multipleSelection === undefined || this.multipleSelection.length !== 1) {
      //   this.$message.error('请选择一条信息修改。')
      //   return
      // }
      this.dialogFormVisible = true
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        // spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const { data: ret } = await this.$http.get(this.$api.adminid + '/' + id)
      if (ret.status === 0 && ret.data !== null) {
        // console.log(ret.data)
        const obj = ret.data
        Object.keys(this.form).forEach(key => {
          this.form[key] = obj[key]
        })
        this.dialogTitle = '修改用户'
      } else {
        this.$message.error(ret.message)
      }
      loading.close()
    },
    saveInfo () {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          console.log('form=', this.form)
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          const { data: ret } = await this.$http.post(this.$api.adminsave, this.form)
          if (ret.status === 0) {
            this.$message.success(ret.message)
            this.getData()
            this.closeForm()
          } else {
            this.$message.error(ret.message)
          }
          loading.close()
        } else {
          this.$message.error('验证没通过。')
          return false
        }
      })
    },
    delInfo () {
      if (this.selectionIds === '') {
        this.$message.error('请选择将删除的信息。')
        return
      }
      this.$confirm('此操作将删除已选择的信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        const { data: ret } = await this.$http.post(this.$api.admindel + '?ids=' + this.selectionIds)
        if (ret.status === 0) {
          this.getData()
          this.$message.success(ret.message)
        } else {
          this.$message.error(ret.message)
        }
        loading.close()
      })
    },
    async enableInfo (bo) {
      const s = bo ? '启用' : '禁用'
      if (this.selectionIds === '') {
        this.$message.error('请选择将' + s + '的信息。')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const params = '?ids=' + this.selectionIds + '&bo=' + bo
      const { data: ret } = await this.$http.post(this.$api.adminenable + params)
      if (ret.status === 0) {
        this.getData()
        this.$message.success(ret.message)
      } else {
        this.$message.error(ret.message)
      }
      loading.close()
    },
    resetForm () {
      this.$refs.formRef.resetFields()
    },
    closeForm () {
      this.$refs.formRef.resetFields()
      this.dialogFormVisible = false
    },
    // 用户角色表数据
    async getRoleData () {
      this.tableRoleLoading = true
      const { data: ret } = await this.$http.get(this.$api.adminrolelist + '?id=' + this.aid)
      if (ret.status === 0) {
        this.userRoleData = ret.data
        this.roleListSelection(this.userRoleData)
        // setTimeout(() => {
        //   this.roleListSelection(this.userRoleData)
        // }, 3000)
      }
      this.tableRoleLoading = false
    },
    setRole () {
      if (this.multipleSelection === undefined || this.multipleSelection.length !== 1) {
        this.$message.error('请选择一条信息设置。')
        return
      }
      this.aid = this.multipleSelection[0].id
      this.getRoleData()
      this.dialogRoleVisible = true
    },
    handleSelectionChangeRole (val) {
      this.selRoleIds = ''
      for (var i = 0; i < val.length; i++) {
        if (this.selRoleIds === '') {
          this.selRoleIds = val[i].id
        } else {
          this.selRoleIds += ',' + val[i].id
        }
      }
    },
    roleListSelection (rows) {
      this.$nextTick(() => {
        this.$refs.userRoleTable.clearSelection()
        if (rows) {
          rows.forEach(row => {
            if (row.ck) {
              this.$refs.userRoleTable.toggleRowSelection(row, true)
            }
          })
        }
      })
    },
    async saveSet () {
      // if (this.selRoleIds === '') {
      //   this.$message.error('你还没有选择角色信息。')
      //   return
      // }
      const params = '?aid=' + this.aid + '&ids=' + this.selRoleIds
      const { data: ret } = await this.$http.post(this.$api.adminsaveset + params)
      if (ret.status === 0) {
        this.closeFormRole()
        this.$message.success(ret.message)
      } else {
        this.$message.error(ret.message)
      }
    },
    closeFormRole () {
      this.aid = ''
      this.dialogRoleVisible = false
    },
    getTableHeight () {
      this.tableHeight = this.clientHeight - 123 - 39
    }
  },
  watch: {
    clientHeight: function (val) {
      this.getTableHeight()
    }
  }
}
</script>

<style lang="less" scoped>
.depatree{
  padding: 8px;
  // border: solid 1px #d3dce6;
}
.align-r{
  text-align: right;
}

</style>
